import React, { Component } from "react";
import CartContext from "./CartContext";
import { Stack, Button, Table, Form, Row, Col, Card } from "react-bootstrap";

export class OrderSummaryPOS extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      couponCode: "",
      couponValue: 0,
      couponData: "",
    };
  }

  StoreCouponDetails = (data) => {
    this.setState({ couponData: data }, () => {
      if (this.state.couponData.couponValueType == 1) {
        if (
          this.state.couponData.amount >
          this.context.getSubTotalPriceInCart(
            this.context.getPOSCartByName(this.context.selectedPOS)
          )
        ) {
          alert(
            `Coupon Value is ${this.state.couponData.amount} which is greater than items in Cart. Add more items to Cart to use this Coupon!`
          );
          this.setState({ couponCode: "" });
          return;
        }
        this.setState(
          { couponValue: Math.round(this.state.couponData.amount, 0) },
          () => {
            this.props.StoreCouponDetails(
              this.state.couponCode,
              this.state.couponValue
            );
          }
        );
      } else if (this.state.couponData.couponValueType == 2) {
        this.setState(
          {
            couponValue: Math.round(
              (this.context.getSubTotalPriceInCart(
                this.context.getPOSCartByName(this.context.selectedPOS)
              ) *
                this.state.couponData.discount) /
                100,
              0
            ),
          },
          () => {
            this.props.StoreCouponDetails(
              this.state.couponCode,
              this.state.couponValue
            );
          }
        );
      }
    });
  };

  OnClickCouponApply = () => {
    if (!this.state.couponCode) return;
    fetch(
      process.env.REACT_APP_API +
        "Consumers/GetCoupon/" +
        this.context.storeId +
        "/" +
        this.state.couponCode
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          alert("Invalid coupon");
          this.setState({ couponCode: "" });
          return;
        }
        this.StoreCouponDetails(data);
      })
      .catch((error) => {
        console.error("OnClickCouponApply error!", error);
        alert("Error: " + error);
      });
  };

  onCouponCodeChange = (e) => {
    this.setState({ couponCode: e.target.value, couponValue: 0 });
    this.props.StoreCouponDetails(e.target.value, 0);
  };

  render() {
    if (this.context.prods.length === 0) return <></>;

    const subTotal = this.context.getSubTotalPriceInCart(
      this.context.getPOSCartByName(this.context.selectedPOS)
    );
    const totalQty = this.context.getTotalQtyInCart(this.props.myCart);
    const tax = this.context.getTaxAmount(
      this.context.getPOSCartByName(this.context.selectedPOS),
      this.state.couponValue
    );
    const savings = this.context.getTotalSavingsFromCart(
      this.context.getPOSCartByName(this.context.selectedPOS)
    );
    const delivery = this.context.getDeliveryAmount(
      this.context.getPOSCartByName(this.context.selectedPOS)
    );
    const grandTotal = this.context.getTotalAmountWithTax(
      this.context.getPOSCartByName(this.context.selectedPOS),
      this.state.couponValue
    );

    return (
      <div className="w-100 p-0 bg-light">
        {window.innerWidth >= 900 ? (
          <Card
            className="shadow-sm border-0 py-1"
            style={{
              backgroundColor: this.context.posBackgroundColor,
              color: this.context.posTextColor,
              borderRadius: "6px",
            }}
          >
            <Card.Body className="py-1 px-2">
              {" "}
              {/* reduce vertical padding */}
              <Row className="text-center align-items-center g-1">
                {" "}
                {/* reduce gutter */}
                <Col>
                  <small className="text-muted">S.Tot:</small>{" "}
                  <b style={{ fontSize: "16px" }}>
                    {subTotal.toLocaleString(
                      this.context.storeSettings?.defaultLocale || "en-IN",
                      {
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    )}
                  </b>
                </Col>
                <Col>
                  <small className="text-muted">Qty:</small>{" "}
                  <b style={{ fontSize: "16px" }}>{totalQty}</b>
                </Col>
                {!this.context.taxDetails.inclusiveOfTax && (
                  <Col>
                    <small className="text-muted">
                      Tax({this.context.taxDetails.taxPercentage}%):
                    </small>{" "}
                    <b style={{ fontSize: "16px" }}>
                      {tax.toLocaleString("en-IN", {
                        style: "currency",
                        currency:
                          this.context.storeSettings?.defaultCurrency || "INR",
                      })}
                    </b>
                  </Col>
                )}
                <Col>
                  <small className="text-success">Save:</small>{" "}
                  <b className="text-success" style={{ fontSize: "16px" }}>
                    {savings.toLocaleString("en-IN", {
                      style: "currency",
                      currency:
                        this.context.storeSettings?.defaultCurrency || "INR",
                    })}
                  </b>
                </Col>
                <Col>
                  <small className="text-muted">Del:</small>{" "}
                  <b style={{ fontSize: "16px" }}>
                    {delivery.toLocaleString("en-IN", {
                      style: "currency",
                      currency:
                        this.context.storeSettings?.defaultCurrency || "INR",
                    })}
                  </b>
                </Col>
                <Col>
                  <small className="text-muted">Total:</small>{" "}
                  <span
                    className="fw-bold text-black"
                    style={{ fontSize: "24px" }}
                  >
                    {grandTotal.toLocaleString("en-IN", {
                      style: "currency",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                      currency:
                        this.context.storeSettings?.defaultCurrency || "INR",
                    })}
                  </span>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ) : (
          <Table className="border m-0 p-0 text-center" size="sm">
            <tbody>
              <Row className="m-0 p-0 text-center bg-dark text-white">
                <Col className="  border">
                  T.Qty
                  <br />
                  <b>
                    {Number(
                      this.context.getTotalQtyInCart(this.props.myCart)
                    ).toFixed(0)}{" "}
                  </b>
                </Col>
                <Col className="  border">
                  S.Tot
                  <h6>
                    <b>
                      {Number(
                        this.context.getSubTotalPriceInCart(
                          this.context.getPOSCartByName(
                            this.context.selectedPOS
                          )
                        )
                      ).toLocaleString(
                        this.context.storeSettings == ""
                          ? "en-IN"
                          : this.context.storeSettings.defaultLocale,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                          style: "currency",
                          currency:
                            this.context.storeSettings == ""
                              ? "INR"
                              : this.context.storeSettings.defaultCurrency,
                        }
                      )}
                    </b>
                  </h6>
                </Col>
                {this.context.taxDetails.inclusiveOfTax == true ? (
                  ""
                ) : (
                  <>
                    <Col className=" border">
                      Tax({this.context.taxDetails.taxPercentage}
                      %)
                      <br />
                      <b>
                        {Number(
                          this.context.getTaxAmount(
                            this.context.getPOSCartByName(
                              this.context.selectedPOS
                            ),
                            this.state.couponValue
                          )
                        ).toLocaleString(
                          this.context.storeSettings == ""
                            ? "en-IN"
                            : this.context.storeSettings.defaultLocale,
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                            style: "currency",
                            currency:
                              this.context.storeSettings == ""
                                ? "INR"
                                : this.context.storeSettings.defaultCurrency,
                          }
                        )}
                      </b>
                    </Col>
                  </>
                )}
                <Col className=" ">
                  Savi
                  <br />
                  <b>
                    {Number(
                      this.context.getTotalSavingsFromCart(
                        this.context.getPOSCartByName(this.context.selectedPOS)
                      )
                    ).toLocaleString(
                      this.context.storeSettings == ""
                        ? "en-IN"
                        : this.context.storeSettings.defaultLocale,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        style: "currency",
                        currency:
                          this.context.storeSettings == ""
                            ? "INR"
                            : this.context.storeSettings.defaultCurrency,
                      }
                    )}
                  </b>
                </Col>
                <Col className="border">
                  Deliv <br />
                  {Number(
                    this.context.getDeliveryAmount(
                      this.context.getPOSCartByName(this.context.selectedPOS)
                    )
                  ).toLocaleString(this.context.storeSettings.defaultLocale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                    style: "currency",
                    currency: this.context.storeSettings.defaultCurrency,
                  })}
                </Col>
                <Col className="border  text-white">
                  <span style={{ fontSize: "24px" }}>
                    <b>
                      {Math.round(
                        this.context.getTotalAmountWithTax(
                          this.context.getPOSCartByName(
                            this.context.selectedPOS
                          ),
                          this.state.couponValue
                        ),
                        0
                      ).toLocaleString(
                        this.context.storeSettings == ""
                          ? "en-IN"
                          : this.context.storeSettings.defaultLocale,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                          style: "currency",
                          currency:
                            this.context.storeSettings == ""
                              ? "INR"
                              : this.context.storeSettings.defaultCurrency,
                        }
                      )}
                    </b>
                  </span>
                </Col>
              </Row>
            </tbody>
          </Table>
        )}
      </div>
    );
  }
}
